import { parseDateOfBirth, type DateIssue } from '../dateHelpers';

export type PersonField = 'firstName' | 'surname' | 'email' | 'phone' | 'gender' | 'dateOfBirth';

/** Order here is the order of the columns, the Missing fields text and the lookup. */
export const PERSON_FIELDS: PersonField[] = [
  'firstName', 'surname', 'email', 'phone', 'gender', 'dateOfBirth',
];

export interface Cleaned {
  value: string | null;
  issue: DateIssue | null;
}

const NONE: Cleaned = { value: null, issue: null };
const PLACEHOLDERS = new Set(['-', '--', '—', '–', 'n/a', 'null', 'undefined']);

/**
 * The one "what counts as missing" rule (plan section 5), used at every stage.
 * Returns the cleaned value, or null when the value is missing.
 *
 * ⚠️ Explicit checks only — never truthiness.
 */
export function cleanField(field: PersonField, raw: unknown): Cleaned {
  if (field === 'dateOfBirth') return parseDateOfBirth(raw);
  if (raw === null || raw === undefined) return NONE;

  const text = String(raw).trim().replace(/\s+/g, ' ');
  if (text === '' || PLACEHOLDERS.has(text.toLowerCase())) return NONE;

  if (field === 'email' && !/^[^\s@]+@[^\s@]+$/.test(text)) return NONE;
  if (field === 'phone' && !/\d/.test(text)) return NONE;

  return { value: text, issue: null };
}

/** Same rule for plain text values such as the location name. */
export function cleanText(raw: unknown): string | null {
  if (raw === null || raw === undefined) return null;
  const text = String(raw).trim();
  return text === '' || PLACEHOLDERS.has(text.toLowerCase()) ? null : text;
}
